import { format } from "date-fns";

import { useTheme } from "@up/data";
import { Animation, Toast, ToastTitle } from "@up/ui";

import type { TScholarship } from "@up/data";

const formatDate = function (date: string) {
  /*
    NOTE: subtract is here as a hack to fix the display of the
    registration deadline. Timezone stuff and what not.
    Revisit in Season 3
  */
  return format(new Date(date), "MMMM d, yyyy");
};

export function ScholarshipThanks({
  scholarship,
}: {
  scholarship: TScholarship;
}) {
  const theme = useTheme();

  return (
    <Animation type="splash-in">
      <Toast variant="success" size="large">
        <ToastTitle autoFocus={true} data-testid="scholarship-thanks-heading">
          Your scholarship application has been received!
        </ToastTitle>
        {scholarship.createdAt ? (
          <p>{formatDate(scholarship.createdAt)}</p>
        ) : null}
      </Toast>

      <div className="pt-4">
        <p>
          You will receive notification of your scholarship determination as a
          separate email from your admissions decision. We generally deliver
          scholarship determinations within one week, though it may take a bit
          longer at peak times.
        </p>
        <br />
        <p>
          If you have any questions please{" "}
          <a className="underline" href={`mailto:${theme.supportEmail}`}>
            email support
          </a>
          .
        </p>
      </div>
    </Animation>
  );
}
